export const data = [
  {
    imgSrc: require('../../assets/radar1.png'),
    code: `import { RadarChart } from "react-native-gifted-charts";

const App = () => {
    return <RadarChart data={[42, 40, 35, 40, 38, 55]} />;
};`
  },
  {
    imgSrc: require('../../assets/labelledRadar.png'),
    code: `import { RadarChart } from "react-native-gifted-charts";

const App = () => {
    return (
        <RadarChart
            data={[42, 40, 35, 40, 38, 55]}
            labels={['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun']}
            labelConfig={{stroke: 'blue', fontWeight: 'bold'}}
            dataLabels={['$42', '$40', '$35', '$40', '$38', '$55']}
            dataLabelsConfig={{stroke: 'brown'}}
            dataLabelsPositionOffset={0}
            maxValue={70}
        />
    );
};`
  },

  {
    imgSrc: require('../../assets/polygon.png'),
    code: `import { RadarChart } from "react-native-gifted-charts";

const App = () => {
    return (
        <RadarChart
            data={[42, 40, 35, 40, 38, 55]}
            hideGrid
            hideLabels
        />
    )
};`
    }
]
